import { render } from "./SelectorSlide.vue?vue&type=template&id=bc9d86e6&scoped=true"
import script from "./SelectorSlide.vue?vue&type=script&lang=js"
export * from "./SelectorSlide.vue?vue&type=script&lang=js"

import "./SelectorSlide.vue?vue&type=style&index=0&id=bc9d86e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9d86e6"]])

export default __exports__